import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "@/constants/site";

const MarqueeRow = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display italic font-light text-2xl sm:text-3xl lg:text-4xl text-cream/90 whitespace-nowrap px-8 sm:px-12">
          {item}
        </span>
        <Sparkle size={14} className="text-gold shrink-0" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section data-testid="marquee-section" className="bg-forest py-8 sm:py-10 overflow-hidden border-y border-gold/20" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      <MarqueeRow />
      <MarqueeRow />
    </div>
  </section>
);

export default Marquee;
